import { CardType } from 'utils/chrome-os/tender-retail-client';

import { BackendCreditTypes } from './backend-credit-types';

const BackendToCardTypeMapping = {
  [CardType.AMEX]: BackendCreditTypes.AMEX,
  [CardType.DISCOVER]: BackendCreditTypes.DISC,
  [CardType.MASTERCARD]: BackendCreditTypes.MC,
  [CardType.VISA]: BackendCreditTypes.VISA,
};

export const mapCreditTypesToBackendTypes = (creditType?: CardType) =>
  BackendToCardTypeMapping[creditType as CardType] || BackendCreditTypes.CREDIT;
